"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestResultStatus = void 0;
var TestResultStatus;
(function (TestResultStatus) {
    TestResultStatus["PENDING"] = "pending";
    TestResultStatus["RUNNING"] = "running";
    TestResultStatus["COMPLETED"] = "completed";
    TestResultStatus["FAILED"] = "failed";
})(TestResultStatus || (exports.TestResultStatus = TestResultStatus = {}));
